// extracted by mini-css-extract-plugin
export var dropdown = "_t6-0";
export var imageWrapper = "_t6-3";
export var itemNameContainer = "_t6-1";
export var productImage = "_t6-2";
export var spinnerWrapper = "_t6-4";